/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * HTML comment marker added to PRs that are closed as part of a stack landing.
 * This allows ReviewStack to distinguish "closed because landed" from
 * "closed because abandoned" when rendering state badges.
 */
export const LANDED_COMMENT_MARKER = '<!-- reviewstack:landed -->\n';

/**
 * Returns true if the given comment body contains the landed marker.
 */
export function hasLandedMarker(body: string | null | undefined): boolean {
  return body != null && body.includes('<!-- reviewstack:landed -->');
}
